import { ILayoutAction } from '../reducer';
import { LayoutConstants } from '../constants';

type ToggleActionCreator = (payload: boolean) => ILayoutAction;

export const toggleAuthoriseAccounts: ToggleActionCreator = (isOpen) => ({
  type: LayoutConstants.LAYOUT_TOGGLE_AUTHORISE_ACCOUNTS,
  payload: isOpen,
});

export const toggleAccountDetails: ToggleActionCreator = (isOpen) => ({
  type: LayoutConstants.LAYOUT_TOGGLE_ACCOUNT_DETAILS,
  payload: isOpen,
});

export const togglePasswordModal: ToggleActionCreator = (isOpen) => ({
  type: LayoutConstants.LAYOUT_TOGGLE_PASSWORD,
  payload: isOpen,
});

export const toggleImagePreviewModal = (isOpen: boolean, src = ''): ILayoutAction => ({
  type: LayoutConstants.LAYOUT_TOGGLE_IMAGE_PREVIEW,
  payload: { isOpen, src },
});

export const toggleAddNewScopesModal: ToggleActionCreator = (isOpen: boolean) => ({
  type: LayoutConstants.LAYOUT_TOGGLE_ADD_NEW_SCOPE,
  payload: isOpen,
});

export const toggleEditPlanModal: ToggleActionCreator = (isOpen: boolean) => ({
  type: LayoutConstants.LAYOUT_TOGGLE_EDIT_PLAN,
  payload: isOpen,
});
